import Validator from 'validatorjs'
import formatErrors from './formatErrors'

const rules = {
  horse_id: 'required|integer',
  price: 'required',
  phone: 'required|string',
  description: 'string',
  type: 'required'
}

export default function validateAddBox (values) {
  values = {...values, price: values.price === 'توافقی' ? 0 : values.price}
  const validator = new Validator(values, rules, {
    required: 'این فیلد الزامی است',
    string: 'متن معتبر نمی‌باشد',
    number: 'این فیلد می بایست عدد باشد'
  })
  validator.passes()
  return formatErrors(validator.errors.all())
}



// WEBPACK FOOTER //
// ./src/utils/validateAdBox.js